import { render, staticRenderFns } from "./facebookCatalog.vue?vue&type=template&id=62ef6944&scoped=true&"
import script from "./facebookCatalog.vue?vue&type=script&lang=js&"
export * from "./facebookCatalog.vue?vue&type=script&lang=js&"
import style0 from "./facebookCatalog.vue?vue&type=style&index=0&id=62ef6944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ef6944",
  null
  
)

export default component.exports